export default __webpack_public_path__ + "static/media/upload.f4f77d1b.svg";